var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.57 43.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f27c23;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.78,
    cy: 21.78,
    r: 21.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.73,25.93c-.37-.37-.93-.48-1.41-.27l-.15.06-.6-.62.11-.13c.8-.89,1.46-1.93,1.8-3.08,1.78-6.02-3.16-11.5-9.07-10.68-3.58.5-6.48,3.4-6.99,6.98-.84,5.89,4.58,10.82,10.57,9.12,1.14-.32,2.17-.95,3.06-1.72l.11-.1.6.62-.07.15c-.22.48-.13,1.05.24,1.42l5.24,5.38c.05.05.12.08.19.08.07,0,.14-.03.19-.08l1.42-1.39c.11-.1.11-.27,0-.38l-5.24-5.38ZM21.04,25.58c-4.62,1.03-8.66-3.01-7.63-7.63.52-2.33,2.4-4.2,4.72-4.72,4.62-1.03,8.66,3.01,7.63,7.63-.52,2.33-2.4,4.21-4.73,4.72Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bb3bbba6415404b2b6efbb55aafc8dec.svg";
export { ForwardRef as ReactComponent };